import { SvgIcon , SvgIconProps} from '@mui/material';
import './ccf-simulator-upload-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfSimulatorUploadIconProps extends SvgIconProps {}

/**
 *
 * @param props -
 * @example
 * @returns
 */
export function CcfSimulatorUploadIcon(props: CcfSimulatorUploadIconProps) {
  return (
    <SvgIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M5.71429 15.2941H14.2857V8.23529H20L10 0L0 8.23529H5.71429V15.2941ZM0 17.6471H20V20H0V17.6471Z"
        fill="#767676"
      />
    </SvgIcon>
  );
}

export default CcfSimulatorUploadIcon;
